import { all, fork, put, call, takeLatest, select } from 'redux-saga/effects';
import * as publicTypes from './publicTypes';
import * as publicActions from './publicActions';
import { setAppLoading } from 'src/modules/app/store/appActions';
import * as publicApi from '../api/publicApi';
import storage from 'src/utils/storageUtils';
import { push } from 'redux-first-history';
import { useSelector } from 'react-redux';
import { getDoctorProfileById, postDoctorProfile, postClinicProfile, getClinicProfileById, getClinics, postCustomPatientFields } from '../api/publicApi';

//POST CLINIC PROFILE 

function* handlePostClinicProfile(action) {
    const { data, resolve, reject } = action.payload;
    try {
        const response = yield call(postClinicProfile, data);
        if (response) {
            yield put(publicActions.postClinicProfileSuccess(response));
            if (resolve) resolve(response)
        }
    } catch (error) {
        yield put(publicActions.postClinicProfileFailure(error));
        if (reject) reject(error)
    }
}

//POST CUSTOM PATIENT FIELDS
function* handlePostCustomPatientFields(action) {
    const { data, resolve, reject } = action.payload;
    try {
        const response = yield call(postCustomPatientFields, data);
        if (response) {
            yield put(publicActions.postCustomPatientFieldsSuccess(response));
            if (resolve) resolve(response)
        }
    } catch (error) {
        yield put(publicActions.postCustomPatientFieldsFailure(error));
        if (reject) reject(error)
    }
}


function* handleGetClinicProfileById(action) {
    const { clinicId, resolve, reject } = action.payload;
    try {
        const response = yield call(getClinicProfileById, clinicId);
        if (response) {
            const profileData = response.profile || response;
            yield put(publicActions.getClinicProfileByIdSuccess(profileData));
            if (resolve) resolve(profileData)
        }
    } catch (error) {
        yield put(publicActions.getClinicProfileByIdFailure(error));
        if (reject) reject(error)
    }
}

//GET CLINICS
function* handleGetClinics(action) {
    const { token, resolve, reject } = action.payload;
    try {
        const response = yield call(getClinics, token);
        if (response) {
            yield put(publicActions.getClinicSuccess(response))
            if (resolve) resolve(response)
        }
    } catch (error) {
        yield put(publicActions.getClinicFailure(error))
        if (reject) reject(error)
    }
}


//POST DOCTOR PROFILE
function* handlePostDoctorProfile(action) {
    const { data, resolve, reject } = action.payload;
    try {
        const response = yield call(postDoctorProfile, data);
        if (response) {
            yield put(publicActions.postDoctorProfileSuccess(response));
            if (resolve) resolve(response)
        }
    } catch (error) {
        yield put(publicActions.postDoctorProfileFailure(error));
        if (reject) reject(error)
    }
}
//GET DOCTOR PROFILE BY ID
function* handleGetDoctorProfileById(action) {
    const { doctId, resolve, reject } = action.payload;
    try {
        const response = yield call(getDoctorProfileById, doctId);
        if (response) {
            const profileData = response.profile || response;
            yield put(publicActions.getDoctorProfileByIdSuccess(profileData));
            if (resolve) resolve(profileData)
        }
    } catch (error) {
        yield put(publicActions.getDoctorProfileByIdFailure(error));
        if (reject) reject(error)
    }
}

export function* watchClinics() {
    yield takeLatest(publicTypes.GET_CLINICPROFILE_BY_ID_REQUEST, handleGetClinicProfileById);
    yield takeLatest(publicTypes.POST_CLINICPROFILE_REQUEST, handlePostClinicProfile);
    yield takeLatest(publicTypes.GET_CLINIC_REQUEST, handleGetClinics);
    yield takeLatest(publicTypes.POST_CUSTOM_PATIENT_FIELDS_REQUEST, handlePostCustomPatientFields);
}

export function* watchDoctor() {
    yield takeLatest(publicTypes.GET_DOCTORPROFILE_BY_ID_REQUEST, handleGetDoctorProfileById);
    yield takeLatest(publicTypes.POST_DOCTORPROFILE_REQUEST, handlePostDoctorProfile);

}
export default function* runSagas() {
    yield all([
        fork(watchDoctor),
        fork(watchClinics)
    ])
}